function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};

(function () {
  if (window.themeCartToast) return;
  var toastTimer = null;
  window.themeCartToast = function (message, duration, variant) {
    if (!message) return;
    var el = document.getElementById('theme-cart-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'theme-cart-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.className = 'cart-toast' + (variant === 'success' ? ' cart-toast--success' : '');
    el.textContent = message;
    el.classList.add('is-visible');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.classList.remove('is-visible');
    }, duration || (variant === 'success' ? 2000 : 3200));
  };
  window.themeCartErrorMessage = function (response, data, fallback) {
    if (response && response.status === 429) {
      return 'Too many requests. Please wait a moment and try again.';
    }
    if (data) {
      if (data.description) return data.description;
      if (data.message) return data.message;
      if (typeof data === 'string' && data.trim()) return data;
    }
    if (response && response.status >= 500) {
      return 'Server error. Please try again in a moment.';
    }
    return fallback || 'Could not update your cart. Please try again.';
  };
})();

window.themeCartVariants = (function () {
  var normalizeProperties = function normalizeProperties(value) {
    var properties = {};
    if (Array.isArray(value)) {
      value.forEach(function (entry) {
        if (Array.isArray(entry) && entry.length >= 2 && entry[0]) properties[entry[0]] = entry[1];
      });
    } else if (value && typeof value === 'object') {
      properties = value;
    }
    return Object.keys(properties).length ? properties : null;
  };

  var readJson = function readJson(picker, selector) {
    var node = picker.querySelector(selector);
    if (!node) return null;
    try {
      return JSON.parse(node.value || node.textContent || '');
    } catch (error) {
      return null;
    }
  };

  var selectedOptions = function selectedOptions(picker) {
    return Array.from(picker.querySelectorAll('[data-cart-option]'))
      .sort(function (a, b) {
        return Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex);
      })
      .map(function (select) {
        return select.value;
      });
  };

  var matchVariant = function matchVariant(variants, options) {
    return variants.find(function (variant) {
      return Array.isArray(variant.options)
        && variant.options.length === options.length
        && variant.options.every(function (option, index) {
          return option === options[index];
        });
    });
  };

  var cartErrorMessage = function cartErrorMessage(data) {
    if (!data) return '';
    if (typeof data.status === 'number' && data.status >= 400) {
      return data.description || data.message || '';
    }
    if (typeof data.errors === 'string') return data.errors;
    if (data.description && !data.items && !data.token && !data.sections) return data.description;
    return '';
  };

  var readResponse = function readResponse(response) {
    return response.text().then(function (text) {
      var data = null;
      try {
        data = text ? JSON.parse(text) : null;
      } catch (error) {
        data = null;
      }
      var message = cartErrorMessage(data);
      if (!response.ok || message) {
        throw new Error(message || window.themeCartErrorMessage(
          response,
          data,
          'Could not update your cart. Please try again.'
        ));
      }
      if (!data) {
        throw new Error(window.themeCartErrorMessage(
          response,
          null,
          'Could not update your cart. Please try again.'
        ));
      }
      return data;
    });
  };

  var postJson = function postJson(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(body)
    }).then(readResponse);
  };

  return {
    present: function present(root) {
      if (!root) return;
      root.querySelectorAll('[data-cart-option]').forEach(function (select) {
        if (window.themeScopedOptions) {
          var values = Array.from(select.options, function (option) {
            return option.value;
          });
          var mode = window.themeScopedOptions.getMode(values);
          if (mode) {
            Array.from(select.options).forEach(function (option) {
              var label = window.themeScopedOptions.getPresentation(option.value, mode).label;
              if (label) option.textContent = label;
            });
          }
        }
        var wrapper = select.closest('.select');
        var selected = select.options[select.selectedIndex];
        if (wrapper) wrapper.dataset.value = selected ? selected.text : '';
      });
    },
    restore: function restore(picker) {
      var variants = readJson(picker, '[data-cart-item-variants]');
      if (!Array.isArray(variants)) return;
      var current = variants.find(function (variant) {
        return String(variant.id) === String(picker.dataset.variantId);
      });
      if (!current || !Array.isArray(current.options)) return;
      picker.querySelectorAll('[data-cart-option]').forEach(function (select) {
        var value = current.options[Number(select.dataset.optionIndex)];
        if (value != null) select.value = value;
      });
      this.present(picker);
    },
    resolve: function resolve(picker) {
      var variants = readJson(picker, '[data-cart-item-variants]');
      var options = selectedOptions(picker);
      var variant = Array.isArray(variants) ? matchVariant(variants, options) : null;
      if (!variant) {
        this.restore(picker);
        window.themeCartToast?.(window.theme?.variantStrings?.unavailable || 'Unavailable');
        return { status: 'rejected' };
      }
      if (String(variant.id) === String(picker.dataset.variantId)) {
        return { status: 'skipped' };
      }
      if (!variant.available) {
        this.restore(picker);
        window.themeCartToast?.(window.theme?.variantStrings?.soldOut || 'Sold out');
        return { status: 'rejected' };
      }
      return { status: 'ready', variant: variant };
    },
    replace: function replace(picker, variant, sections) {
      var quantity = Number(picker.dataset.quantity);
      var item = {
        id: variant.id,
        quantity: quantity > 0 ? quantity : 1
      };
      var properties = normalizeProperties(readJson(picker, '[data-cart-item-properties]'));
      if (properties) item.properties = properties;
      if (picker.dataset.sellingPlan) {
        item.selling_plan = Number(picker.dataset.sellingPlan);
      }

      var added = false;
      return postJson(theme.routes.cart_add_url + '.js', { items: [item] })
        .then(function () {
          added = true;
          return postJson(theme.routes.cart_change_url, {
            id: picker.dataset.key,
            quantity: 0,
            sections: sections,
            sections_url: window.location.pathname
          });
        })
        .then(function (state) {
          return { status: 'done', state: state };
        })
        .catch(function (error) {
          if (!added) {
            window.themeCartVariants.restore(picker);
            window.themeCartToast?.(
              (error && error.message) || 'Could not update your cart. Please try again.'
            );
            return { status: 'rejected' };
          }
          window.themeCartToast?.(
            (error && error.message) || 'Could not update your cart. Please try again.'
          );
          return fetch(window.location.pathname + '?sections=' + sections.join(','))
            .then(function (response) {
              return readResponse(response);
            })
            .then(function (parsedState) {
              return { status: 'done', state: { sections: parsedState } };
            })
            .catch(function () {
              return { status: 'partial' };
            });
        });
    }
  };
})();

var HEADER_DRAWER_IDS = ['Search-Drawer', 'Notification-Drawer', 'Cart-Drawer'];

var closeHeaderDrawers = function closeHeaderDrawers() {
  var exceptId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  HEADER_DRAWER_IDS.forEach((drawerId) => {
    if (drawerId === exceptId) {
      return;
    }

    var drawer = document.getElementById(drawerId);
    if (!drawer) {
      return;
    }

    drawer.classList.remove('active');
    drawer.querySelector('.product-recommendations--full')?.classList.remove('active');
  });

  document.body.classList.remove('open-search');
  document.body.classList.remove('open-cart');

  if (!exceptId) {
    document.body.classList.remove('open-cc');
  }
};

var openHeaderDrawer = function openHeaderDrawer(drawerId) {
  var bodyClasses = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  closeHeaderDrawers(drawerId);
  var drawer = document.getElementById(drawerId);

  if (!drawer) {
    return null;
  }

  document.body.classList.add('open-cc');
  bodyClasses.forEach((className) => document.body.classList.add(className));
  drawer.classList.add('active');
  return drawer;
};

window.themeHeaderDrawers = {
  close: closeHeaderDrawers,
  open: openHeaderDrawer
};
window.recentlyViewedIds = [];

/**
 * Bind cart toggle once at document level (capture).
 * Prevents first-click navigation to /cart before/without CartDrawer wiring,
 * and avoids duplicate listeners when the drawer re-renders.
 */
if (!window.__cartDrawerToggleBound) {
  window.__cartDrawerToggleBound = true;

  var openCartDrawerFromToggle = function openCartDrawerFromToggle() {
    var drawer = window.themeHeaderDrawers.open('Cart-Drawer', ['open-cart']);
    if (!drawer) return null;
    drawer.focus();
    setTimeout(() => {
      drawer.querySelector('.product-recommendations--full')?.classList.add('active');
    });
    dispatchCustomEvent('cart-drawer:open');
    return drawer;
  };

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('#cart-drawer-toggle');
    if (!toggle) return;
    event.preventDefault();
    openCartDrawerFromToggle();
  }, true);

  if (window.__pendingCartDrawer) {
    window.__pendingCartDrawer = false;
    openCartDrawerFromToggle();
  }
}
/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      this.step = this.input.getAttribute('step');
      this.changeEvent = new Event('change', {
        bubbles: true
      });
      // Create buttons
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      // Add functionality to buttons
      this.subtract.addEventListener('click', () => this.change_quantity(-1 * this.step));
      this.add.addEventListener('click', () => this.change_quantity(1 * this.step));

    }
    connectedCallback() {
      this.classList.add('buttons_added');
      this.validateQtyRules();
    }
    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value);

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1;

      // Check for min & max
      if (this.input.getAttribute('min') > (quantity + change)) {
        return;
      }
      if (this.input.getAttribute('max')) {
        if (this.input.getAttribute('max') < (quantity + change)) {
          return;
        }
      }
      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      quantity = Math.max(quantity, 1);

      // Output number
      this.input.value = quantity;

      this.input.dispatchEvent(this.changeEvent);

      this.validateQtyRules();
    }
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        this.subtract.classList.toggle('disabled', value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        this.add.classList.toggle('disabled', value >= max);
      }
    }
  }
  customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {

  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');

    } else {
      submenu.classList.remove('active');
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-card--featured-image-link .product-primary-image');
      this.additional_images = this.querySelectorAll('.product-secondary-image');
      this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
      this.size_options = this.querySelector('.product-card-sizes');
    }
    connectedCallback() {
      this.initializeScopedOptions();
      if (this.swatches) {
        this.enableSwatches(this.swatches, this.image);
      }
      if (this.additional_images) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
      if (this.size_options) {
        this.enableSizeOptions();
      }
      this.applyScopedCardOptions();
    }
    initializeScopedOptions() {
      const scopeOptions = this.querySelector('[data-scope-options]');
      if (!scopeOptions) return;

      const values = JSON.parse(scopeOptions.textContent).flat();
      this.scopeMode = window.themeScopedOptions.getMode(values);
      const optionsSource = this.size_options || this.swatches;
      this.current_options = JSON.parse(optionsSource.dataset.options);
      this.querySelectorAll('[data-option-value]').forEach((option) => {
        option.querySelector('[data-option-label]').textContent = window.themeScopedOptions.getPresentation(option.dataset.optionValue, this.scopeMode).label;
      });
      this.reconcileScopedCardOptions();
    }
    reconcileScopedCardOptions() {
      if (!this.scopeMode || !this.current_options) return;

      const optionsByIndex = new Map();
      this.querySelectorAll('[data-option-value]').forEach((option) => {
        const index = Number(option.closest('[data-index]').dataset.index);
        if (!optionsByIndex.has(index)) optionsByIndex.set(index, []);
        optionsByIndex.get(index).push(option);
      });

      [...optionsByIndex.entries()].sort(([a], [b]) => a - b).forEach(([index]) => {
        const selectedPresentation = window.themeScopedOptions.getPresentation(this.current_options[index], this.scopeMode);
        if (window.themeScopedOptions.matches(selectedPresentation, this.current_options.slice(0, index))) return;
        this.current_options[index] = null;
      });
    }
    applyScopedCardOptions() {
      if (!this.current_options) return;

      const states = new Map();
      const apply = (option, index) => {
        const value = option.dataset.optionValue;
        const presentation = window.themeScopedOptions.getPresentation(value, this.scopeMode);
        const isMatch = window.themeScopedOptions.matches(presentation, this.current_options.slice(0, index));
        const isActive = this.current_options[index] === value;
        const isHidden = presentation.operator === '!!' && !isMatch;
        const isDisabled = presentation.operator === '::' && !isMatch;

        option.hidden = isHidden;
        option.classList.toggle('is-scope-disabled', isDisabled);
        option.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
        states.set(option, { isActive, isHidden });
      };

      this.querySelectorAll('.product-card-swatch[data-option-value]').forEach((option) => apply(option, Number(this.color_index)));
      this.querySelectorAll('.product-card-sizes--size[data-option-value]').forEach((option) => apply(option, Number(this.size_index)));

      if (this.size_options) {
        const sizes = Array.from(this.size_options.querySelectorAll('.product-card-sizes--size'));
        const candidates = sizes.filter((size) => !states.get(size).isHidden);
        const limit = Number(this.size_options.dataset.limit);
        const activeSize = candidates.find((size) => states.get(size).isActive);
        const visibleSizes = candidates.slice(0, limit);

        if (this.scopeMode && activeSize && !visibleSizes.includes(activeSize)) {
          visibleSizes.splice(Math.max(0, limit - 1), 1, activeSize);
        }

        sizes.forEach((size) => {
          size.hidden = states.get(size).isHidden || !visibleSizes.includes(size);
        });

        const remaining = this.size_options.parentElement.querySelector('.product-card-sizes--remaining');
        const remainingCount = candidates.length - visibleSizes.length;
        if (remaining) {
          remaining.textContent = `+${remainingCount}`;
          remaining.hidden = remainingCount === 0;
        }

        const hasInScopeSize = visibleSizes.some((size) => !size.classList.contains('is-scope-disabled'));
        this.size_options.parentElement.hidden = !hasInScopeSize && !activeSize;
      }

      if (this.swatches) {
        const swatches = Array.from(this.swatches.querySelectorAll('.product-card-swatch'));
        const hasSelectableSwatch = swatches.some((swatch) => !swatch.hidden && !swatch.classList.contains('is-scope-disabled'));
        const hasActiveSwatch = swatches.some((swatch) => states.get(swatch).isActive);
        this.swatches.parentElement.hidden = !hasSelectableSwatch && !hasActiveSwatch;
      }
    }
    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector('.product-card--featured-image-link');
      const mousemove = function (e) {
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];
        images.forEach((image, index) => {
          if (image.classList.contains('hover')) {
            image.classList.remove('hover');
            if (nav.length) {
              nav[index].classList.remove('active');
            }
          }
        });
        if (selimg) {
          if (!selimg.classList.contains('hover')) {
            selimg.classList.add('hover');
            if (nav.length) {
              nav[sel].classList.add('active');
            }
          }
        }

      };
      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove('hover');
          if (nav.length) {
            nav[index].classList.remove('active');
          }
        });
      };
      if (image_container) {
        image_container.addEventListener('touchstart', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchmove', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchend', mouseleave, {
          passive: true
        });
        image_container.addEventListener('mouseenter', mousemove, {
          passive: true
        });
        image_container.addEventListener('mousemove', mousemove, {
          passive: true
        });
        image_container.addEventListener('mouseleave', mouseleave, {
          passive: true
        });
      }

      images.forEach(function (image) {
        window.addEventListener('load', (event) => {
          lazySizes.loader.unveil(image);
        });
      });

    }
    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll('.product-card-swatch'),
        org_srcset = image ? image.dataset.srcset : '';
      this.color_index = this.swatches.dataset.index;

      swatch_list.forEach((swatch, index) => {
        window.addEventListener('load', (event) => {
          let image = new Image();
          image.srcset = swatch.dataset.srcset;
          lazySizes.loader.unveil(image);
        });

        swatch.addEventListener('mouseover', () => {
          if (swatch.hidden || swatch.classList.contains('is-scope-disabled')) return;
          [].forEach.call(swatch_list, function (el) {
            el.classList.remove('active');
          });
          if (image) {
            if (swatch.dataset.srcset) {
              image.setAttribute('srcset', swatch.dataset.srcset);
            } else {
              image.setAttribute('srcset', org_srcset);
            }
          }
          this.current_options[this.color_index] = swatch.dataset.optionValue;
          this.reconcileScopedCardOptions();
          if (this.size_options) this.updateMasterId();
          else this.applyScopedCardOptions();
          swatch.classList.add('active');
        });
        swatch.addEventListener('click', function (evt) {
          if (this.hidden || this.classList.contains('is-scope-disabled')) {
            evt.preventDefault();
            return;
          }
          window.location.href = this.dataset.href;
          evt.preventDefault();
        });
      });
    }
    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }
    enableSizeOptions() {
      let size_list = this.size_options.querySelectorAll('.product-card-sizes--size'),
        featured_image = this.querySelector('.product-card--featured-image'),
        has_hover = featured_image.classList.contains('thb-hover'),
        size_parent = this.size_options.parentElement;

      this.size_index = this.size_options.dataset.index;

      this.updateMasterId();

      size_parent.addEventListener('mouseenter', () => {
        if (has_hover) {
          featured_image.classList.remove('thb-hover');
        }
      }, {
        passive: true
      });
      size_parent.addEventListener('mouseleave', () => {
        if (has_hover) {
          featured_image.classList.add('thb-hover');
        }
      }, {
        passive: true
      });
      size_list.forEach((size) => {
        size.addEventListener('click', (evt) => {
          evt.preventDefault();

          if (size.classList.contains('is-disabled') || size.classList.contains('is-scope-disabled')) {
            return;
          }
          this.current_options[this.size_index] = size.dataset.optionValue;
          this.updateMasterId();

          size.classList.add('loading');
          size.setAttribute('aria-disabled', true);
          const config = {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'Accept': 'application/javascript'
            }
          };
          let formData = new FormData();

          formData.append('id', this.currentVariant.id);
          formData.append('quantity', 1);
          formData.append('sections', this.getSectionsToRender().map((section) => section.section));
          formData.append('sections_url', window.location.pathname);

          config.body = formData;

          fetch(`${theme.routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                window.themeCartToast?.(
                  window.themeCartErrorMessage?.(null, response, 'Could not add to cart. Please try again.')
                  || 'Could not add to cart. Please try again.'
                );
                return;
              }
              this.renderContents(response);
              window.themeCartToast?.('Added to cart.', 2000, 'success');

              dispatchCustomEvent('cart:item-added', {
                product: response.hasOwnProperty('items') ? response.items[0] : response
              });
            })
            .catch((e) => {
              console.error(e);
              window.themeCartToast?.(
                (e && e.message) || 'Network error. Please check your connection.'
              );
            })
            .finally(() => {
              size.classList.remove('loading');
              size.removeAttribute('aria-disabled');
            });
        });
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.current_options[index] === option;
        }).includes(false);
      });
      setTimeout(() => {
        this.setDisabled();
      }, 100);
    }
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
    setDisabled() {
      const variant_data = this.getVariantData();

      if (variant_data) {

        if (this.currentVariant) {
          const selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });

          const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

          const fieldset_options = Object.values(available_options)[this.size_index];
          if (fieldset_options) {
            if (this.size_options.querySelectorAll('.product-card-sizes--size').length) {
              this.size_options.querySelectorAll('.product-card-sizes--size').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        } else {
          if (this.size_options.querySelectorAll('.product-card-sizes--size').length) {
            this.size_options.querySelectorAll('.product-card-sizes--size').forEach((input) => {
              const value = input.dataset.optionValue;
              const isAvailable = variant_data.some((variant) => {
                if (!variant.available || variant.options[this.size_index] !== value) return false;
                return this.current_options.every((selected, index) => {
                  return index === Number(this.size_index) || selected == null || variant.options[index] === selected;
                });
              });
              input.classList.toggle('is-disabled', !isAvailable);
            });
          }
        }

      }
      this.applyScopedCardOptions();
      return true;
    }
    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }
    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData();

      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json().then((data) => ({ response, data })))
        .then(({ response, data }) => {
          if (!response.ok || (data && data.status)) {
            window.themeCartToast?.(
              window.themeCartErrorMessage?.(
                response,
                data,
                'Could not add to cart. Please try again.'
              ) || 'Could not add to cart. Please try again.'
            );
            return;
          }
          this.renderContents(data);
          window.themeCartToast?.('Added to cart.', 2000, 'success');

          dispatchCustomEvent('cart:item-added', {
            product: data.hasOwnProperty('items') ? data.items[0] : data
          });
        })
        .catch((e) => {
          console.error(e);
          window.themeCartToast?.(
            (e && e.message) || 'Network error. Please check your connection.'
          );
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (section.id === 'Cart-Drawer') {
          document.getElementById('Cart-Drawer')?.notesToggle();
          document.getElementById('Cart-Drawer')?.removeProductEvent();
        }

        if (section.id === 'Cart' && typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));


      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').classList.add('active');
        document.body.classList.add('open-cart');
        document.body.classList.add('open-cc');
        if (document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full')) {
          document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
        }
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);
}


/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get('side-panel-close')) {
  class PanelClose extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector('.click-capture');

      this.onClick = (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel.length) {
          this.close_panel(e, panel[0]);
        }
      };
      // Add functionality to buttons
      this.addEventListener('click', this.onClick.bind(this));
      document.addEventListener('panel:close', this.onClick.bind(this));
      if (!this.cc.hasAttribute('initialized')) {
        this.cc.addEventListener('click', this.onClick.bind(this));
        this.cc.setAttribute('initialized', '');
      }

    }
    close_panel(e, panel) {
      if (e) {
        e.preventDefault();
      }
      if (!panel) {
        panel = e?.target.closest('.side-panel.active');

        if (!panel) {
          return;
        }
      }
      if (panel.classList.contains('product-drawer') || document.body.classList.contains('open-quick-view')) {
        this.close_quick_view();
      } else if (panel.classList.contains('cart-drawer')) {
        if (panel.querySelector('.product-recommendations--full')) {
          if (!document.body.classList.contains('open-quick-view')) {
            panel.querySelector('.product-recommendations--full').classList.remove('active');
          }
        }
        if (window.innerWidth < 1069) {
          if (!document.body.classList.contains('open-quick-view')) {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
            document.body.classList.remove('open-cart');
          } else {
            this.close_quick_view();
          }
        } else {
          if (panel.querySelector('.product-recommendations--full')) {
            if (!document.body.classList.contains('open-quick-view')) {
              setTimeout(() => {
                panel.classList.remove('active');
                document.body.classList.remove('open-cc');
                document.body.classList.remove('open-cart');
              }, 500);
            } else {
              this.close_quick_view();
            }
          } else {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
            document.body.classList.remove('open-cart');
          }
        }
      } else {
        panel.classList.remove('active');
        document.body.classList.remove('open-cc');
        document.body.classList.remove('open-search');
      }
    }
    close_quick_view() {
      let panel = document.getElementById('Product-Drawer');

      if (panel.querySelector('.product-quick-images--container')) {
        panel.querySelector('.product-quick-images--container').classList.remove('active');
      }
      if (window.innerWidth < 1069) {
        panel.classList.remove('active');
        if (!document.body.classList.contains('open-cart') || !document.body.classList.contains('open-quick-view')) {
          document.body.classList.remove('open-cc');
        }
        document.body.classList.remove('open-quick-view');
      } else {
        if (panel.querySelector('.product-quick-images--container')) {
          setTimeout(() => {
            panel.classList.remove('active');
            if (!document.body.classList.contains('open-cart') || !document.body.classList.contains('open-quick-view')) {
              document.body.classList.remove('open-cc');
            }
            document.body.classList.remove('open-quick-view');
            panel.querySelector('#Product-Drawer-Content').innerHTML = '';
          }, 500);
        }
      }
    }
  }
  customElements.define('side-panel-close', PanelClose);

  document.addEventListener('keyup', (e) => {
    if (e.code) {
      if (e.code.toUpperCase() === 'ESCAPE') {
        dispatchCustomEvent('panel:close');
      }
    }
  });
}
/**
 *  @class
 *  @function CartDrawer
 */
if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {
      // Cart toggle is bound once at document level in app.js bootstrap.
      // Keep only drawer-internal behaviors here.

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      document.addEventListener('cart:refresh', (event) => {
        if (event.detail?.source === 'cart-drawer') return;
        this.refresh();
      });

      this.addEventListener('change', this.debouncedOnChange.bind(this));
      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-cart-option]')) this.changeVariant(event.target);
      });

      this.notesToggle();
      this.removeProductEvent();
      window.themeCartVariants.present(this);
    }
    onChange(event) {
      if (event.target.matches('[data-cart-option]')) return;
      if (event.target.classList.contains('qty')) {
        this.updateQuantity(event.target.dataset.index, event.target.value);
      }
    }
    changeVariant(select) {
      if (this.classList.contains('cart-disabled')) return;
      const picker = select.closest('[data-cart-variant-picker]');
      if (!picker) return;
      window.themeCartVariants.present(picker);
      const resolution = window.themeCartVariants.resolve(picker);
      if (resolution.status !== 'ready') return;

      const line = picker.dataset.line;
      const quantity = picker.dataset.quantity;
      this.classList.add('cart-disabled');
      this.querySelector(`#CartDrawerItem-${line}`)?.classList.add('thb-loading');
      dispatchCustomEvent('line-item:change:start', {
        quantity: quantity
      });

      window.themeCartVariants.replace(
        picker,
        resolution.variant,
        this.getSectionsToRender().map((section) => section.section)
      ).then((result) => {
        if (result.status !== 'done' || !result.state?.sections) return;
        this.renderSections(result.state);
        dispatchCustomEvent('line-item:change:end', {
          quantity: quantity,
          cart: result.state
        });
        dispatchCustomEvent('cart:refresh', { source: 'cart-drawer' });
      }).finally(() => {
        this.classList.remove('cart-disabled');
        this.querySelector(`#CartDrawerItem-${line}`)?.classList.remove('thb-loading');
      });
    }
    renderSections(parsedState) {
      this.getSectionsToRender().forEach((section => {
        const elementToReplace = document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
        if (!elementToReplace || !parsedState.sections?.[section.section]) return;
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }));
      this.removeProductEvent();
      this.notesToggle();
      window.themeCartVariants.present(this);
    }
    removeProductEvent() {
      let removes = this.querySelectorAll('.remove');

      removes.forEach((remove) => {
        remove.addEventListener('click', (event) => {
          this.updateQuantity(event.currentTarget.dataset.index, '0');

          event.preventDefault();
        });
      });
    }
    getSectionsToRender() {
      return [{
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    notesToggle() {
      let notes_toggle = document.getElementById('order-note-toggle');

      if (!notes_toggle) {
        return;
      }

      notes_toggle.addEventListener('click', (event) => {
        notes_toggle.nextElementSibling.classList.add('active');
      });
      notes_toggle.nextElementSibling.querySelectorAll('.button, .order-note-toggle__content-overlay').forEach((el) => {
        el.addEventListener('click', (event) => {
          notes_toggle.nextElementSibling.classList.remove('active');
          this.saveNotes();
        });
      });
    }
    saveNotes() {
      fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        body: JSON.stringify({
          'note': document.getElementById('mini-cart__notes').value
        })
      });
    }
    updateQuantity(line, quantity) {
      if (this.classList.contains('cart-disabled')) return;
      this.classList.add('cart-disabled');
      const lineItem = this.querySelector(`#CartDrawerItem-${line}`);
      lineItem?.classList.add('thb-loading');
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      dispatchCustomEvent('line-item:change:start', {
        quantity: quantity
      });
      this.querySelector('.product-recommendations--full')?.classList.remove('active');

      fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        body
      })
        .then(async (response) => {
          const text = await response.text();
          let parsedState = null;
          try {
            parsedState = JSON.parse(text);
          } catch (e) {
            parsedState = null;
          }
          if (!response.ok) {
            throw new Error(window.themeCartErrorMessage(
              response,
              parsedState,
              'Could not update your cart. Please try again.'
            ));
          }
          if (!parsedState) {
            throw new Error(window.themeCartErrorMessage(
              response,
              null,
              'Could not update your cart. Please try again.'
            ));
          }
          return parsedState;
        })
        .then((parsedState) => {
          this.renderSections(parsedState);
          dispatchCustomEvent('line-item:change:end', {
            quantity: quantity,
            cart: parsedState
          });
        })
        .catch((error) => {
          console.error('Error updating quantity:', error);
          lineItem?.classList.remove('thb-loading');
          window.themeCartToast?.(
            (error && error.message) || 'Could not update your cart. Please try again.'
          );
        })
        .finally(() => {
          this.classList.remove('cart-disabled');
          this.querySelector(`#CartDrawerItem-${line}`)?.classList.remove('thb-loading');
        });
    }
    refresh() {
      this.querySelector('.product-recommendations--full')?.classList.remove('active');
      let sections = 'cart-drawer,cart-bubble';
      fetch(`${window.location.pathname}?sections=${sections}`)
        .then(async (response) => {
          const text = await response.text();
          if (!response.ok) {
            let data = null;
            try { data = JSON.parse(text); } catch (e) {}
            throw new Error(window.themeCartErrorMessage(
              response,
              data,
              'Cart updated, but the drawer could not refresh. Please reload the page.'
            ));
          }
          return JSON.parse(text);
        })
        .then((parsedState) => {
          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
          }));

          this.removeProductEvent();
          this.notesToggle();
          window.themeCartVariants.present(this);
        })
        .catch((error) => {
          console.error('Error refreshing cart:', error);
          window.themeCartToast?.(
            (error && error.message) || 'Cart updated, but the drawer could not refresh. Please reload the page.'
          );
        });
    }
  }
  customElements.define('cart-drawer', CartDrawer);
}

/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    // resize on initial load
    window.addEventListener('load', () => {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });

    // delegated listener on change
    document.body.addEventListener('change', (e) => {
      if (e.target.matches('.resize-select') && e.target.offsetParent !== null) {
        _this.resizeSelect(e.target);
      }
    });
    window.addEventListener('resize.resize-select', function () {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });
  }

  resizeSelect(sel) {
    let tempOption = document.createElement('option');
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement('select'),
      offset = 13;
    tempSelect.style.visibility = 'hidden';
    tempSelect.style.position = 'fixed';
    tempSelect.appendChild(tempOption);
    if (sel.classList.contains('thb-language-code') || sel.classList.contains('thb-currency-code') || sel.classList.contains('facet-filters__sort')) {
      offset = 2;
    }
    sel.after(tempSelect);
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + offset}px`;
    }
    tempSelect.remove();
  }
}

if (typeof SelectWidth !== 'undefined') {
  new SelectWidth();
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll('.thb-widget-title.collapsible').forEach((button) => {
      button.addEventListener('click', (e) => {
        button.classList.toggle('active');
      });
    });
  }
}

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.drawer = document.getElementById('Product-Drawer');
      this.body = document.body;

      this.addEventListener('click', this.setupEventListener.bind(this));

    }
    setupEventListener(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace('//', '/');
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains('loading')) {
        return;
      }
      this.classList.add('loading');
      fetch(href, {
        method: 'GET'
      })
        .then((response) => {
          this.classList.remove('loading');
          return response.text();
        })
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Drawer-Content').innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle);

        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {

        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;

        let js_files = this.drawer.querySelector('#Product-Drawer-Content').querySelectorAll('script');

        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement('script');
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);

        this.body.classList.add('open-cc');
        this.body.classList.add('open-quick-view');
        this.drawer.classList.add('active');

        this.drawer.querySelector('.side-panel-close').focus();

        setTimeout(() => {
          this.drawer.querySelector('.product-quick-images--container').classList.add('active');
        });
        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle
        });
        addIdToRecentlyViewed(productHandle);
      }
    }
  }
  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get('side-panel-content-tabs')) {
  class SidePanelContentTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('button');
      this.panels = this.parentElement.querySelectorAll('.side-panel-content--tab-panel');
    }
    connectedCallback() {
      this.setupButtonObservers();
    }
    disconnectedCallback() {

    }
    setupButtonObservers() {
      this.buttons.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.toggleActiveClass(i);
        });
      });
    }
    toggleActiveClass(i) {
      this.buttons.forEach((button) => {
        button.classList.remove('tab-active');
      });
      this.buttons[i].classList.add('tab-active');

      this.panels.forEach((panel) => {
        panel.classList.remove('tab-active');
      });
      this.panels[i].classList.add('tab-active');
    }
  }

  customElements.define('side-panel-content-tabs', SidePanelContentTabs);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {

  if (!handle) {
    let product = document.querySelector('.thb-product-detail');

    if (product) {
      handle = product.dataset.handle;
    }
  }
  if (!handle) {
    return;
  }
  if (!Array.isArray(window.recentlyViewedIds)) {
    window.recentlyViewedIds = [];
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds != 'undefined' && recentIds != null) {
      try {
        const parsed = JSON.parse(recentIds);
        if (Array.isArray(parsed)) {
          window.recentlyViewedIds = parsed;
        }
      } catch (e) {}
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}

document.addEventListener('click', async function (e) {
  const buyNowBtn = e.target.closest('.shopify-payment-button__button');
  if (!buyNowBtn || buyNowBtn.tagName !== 'BUTTON') return;

  e.preventDefault();
  if (buyNowBtn.disabled) return;

  const productFormEl = buyNowBtn.closest('product-form');
  const form = productFormEl?.querySelector('form[data-type="add-to-cart-form"]')
    || buyNowBtn.closest('form');
  if (!form) return;

  const variantInput = form.querySelector('[name="id"]');
  const quantityInput = form.querySelector('[name="quantity"]');
  if (!variantInput?.value) return;

  const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
    || (window.theme && window.theme.routes && window.theme.routes.root_url)
    || '/';

  buyNowBtn.disabled = true;
  const originalText = buyNowBtn.textContent;
  buyNowBtn.textContent = 'Processing...';

  try {
    const orderNote = window.themeProductOrderNote?.getNote?.(form) || '';

    const clearResponse = await fetch(rootUrl + 'cart/clear.js', { method: 'POST' });
    if (!clearResponse.ok) throw new Error('Failed to clear cart');

    const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
    const addResponse = await fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: variantInput.value,
          quantity: quantity
        }]
      })
    });

    if (!addResponse.ok) throw new Error('Add to cart failed');

    if (window.themeProductOrderNote?.save) {
      await window.themeProductOrderNote.save(orderNote);
    }

    window.location.href = rootUrl + 'checkout';
  } catch (error) {
    console.error('Buy It Now Error:', error);
    buyNowBtn.disabled = false;
    buyNowBtn.textContent = originalText;

    const errorWrapper = productFormEl?.querySelector('.product-form__error-message-wrapper');
    if (errorWrapper) {
      errorWrapper.removeAttribute('hidden');
      const messageEl = errorWrapper.querySelector('.product-form__error-message');
      if (messageEl) {
        messageEl.textContent = 'An error occurred. Please try again.';
      }
    }
  }
});

document.addEventListener('DOMContentLoaded', () => {
  if (typeof FooterMenuToggle !== 'undefined') {
    new FooterMenuToggle();
  }
});
